export default __webpack_public_path__ + "static/Uso-del-Cloud-8bad8050afcc9e8e90b704be99bb34d3.jpg";